import React, { Component } from "react";
import ArticleComments from "./ArticleComments"
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';


class Friday3 extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }

    var answerStyle = {
      fontSize:16
    }


    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>

        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Friday Night Blitz 3: Tournament Recap</h1>

          <p style={size13}>
            By: Psynight - April 14, 2018
          </p>

          <img src={"../ArticleImages/Surprise.jpg"} style={imgCenterStyle} className="img-fluid" id="surprise" alt="surprise" />
          <p style={answerStyle}>
          We had our third tournament Friday night with 14 players participating, almost doubled the size again.  I have no doubts that the new prize structure plays a part in that.
          </p>
          <p>You read that right, Dragon Foundry has announced a <a href="https://docsend.com/view/5mw2j9u">Player Run Tournament Program</a> complete with a prize structure.
          Including a participation prize just for playing in and completing the tournament.
          </p>
          <p style={answerStyle}>
          We had some repeat players: Uni, Psynight (myself), Siba, Niboshi, and Krighton.  We also had quiet a few new faces: Grimm, Upclass, Eyecandi, Okku, Adinalini, Pack, Cva, Yuuhika, and Adonc1980.
          Five of our competitors are currently sitting in the top 10 on the April leaderboard, so there was some strong competition this tournament.  At least at the top of the standings, my deck sadly
          performed way below expections.
          </p>
          <p>
          Here are the final standings along with the decks that were brought:
          </p>
          <ol>
            <li>Uni brought <Link to={routes.DECKVIEW + "ywJImNexRzMaLHlv8euc"}>"chaos/nature"</Link></li>
            <li>Siba brought <Link to={routes.DECKVIEW + "0X8WpjyyTyRwbhU1fowK"}>"Gyaos"</Link></li>
            <li>Grimm brought <Link to={routes.DECKVIEW + "SalRE0DnWEzrfvFQZhLk"}>"Last Breath"</Link></li>
            <li>Okku brought <Link to={routes.DECKVIEW + "WcHaeA73Zai0Fg7gl0hP"}>"TORIISOGI"</Link></li>
            <li>Upclass brought <Link to={routes.DECKVIEW + "IalTRXRjqdu4WWvEhD9r"}>"Damage Control (Budget)"</Link></li>
            <li>Niboshi brought <Link to={routes.DECKVIEW + "FCBasKiuVKwoCHjBdURL"}>"Chaos Arcane Agro"</Link></li>
            <li>Yuuhika brought <Link to={routes.DECKVIEW + "aN3BPU8JY2Jtsw0VUQ5M"}>"ゴブリン"</Link></li>
            <li>Eyecandi brought <Link to={routes.DECKVIEW + "jiqc2Xo1zpzvh1U2cBQt"}>"Heavy liftoff"</Link></li>
            <li>Cva brought <Link to={routes.DECKVIEW + "T5sMOxfUy9py57kxHgpJ"}>"DA-Control"</Link></li>
            <li>Adonc1980</li>
            <li>Krighton </li>
            <li>Pack </li>
            <li>Adinalini brought <Link to={routes.DECKVIEW + "tcmKWEvd4v37EH7ZvUrj"}>"Nature's Verdict"</Link></li>
            <li>Psynight brought <Link to={routes.DECKVIEW + "hzjbRO3zUL0FGZNI2gtv"}>"Grand Theft"</Link></li>
          </ol>

          <h5> Highlights </h5>
          <p>
            {"Congrats to Uni on winning the tournament for the 3rd week in a row!  Him and Siba brought decks that have brought them success before.  Are those currently the decks to beat?  Time will tell."}
          </p>
          <p>
          {"My deck did particularly bad.  It is a heavy control deck, but it's finisher is stealing my opponents big minions and killing them with them.  Unfortunately going up against other control decks that were a bit more aggressive meant I was playing on the back foot and they were able to kill what I stole."}
          </p>
          <p style={answerStyle}>
          {"Uni's aggressive Nature Chaos deck isn't showing signs of slowing down.  Siba's Kaiju Egg deck is also showing resilenece as the field starts to adapt to it."}
          </p>
          <p style={answerStyle}>
          {"The deck that Grimm brought is probably the one I am most excited about, it's unique at least to this tournament and from a crafting cost perspective is one of the lowest.  Lantern Lich seems to work as a sacrifice engine, with Kenji and the last breath cards feeding it.  The deck focuses on grinding your opponent down over time."}
          </p>
          <h5>Deck Breakdown</h5>
          <p style={answerStyle}>
          {"Of the 11 decks registered, we had no Technology representation. Six decks had Chaos, and six decks had Arcane.  Chaos Arcane and Divine Arcane were the most represented combos at 3 apiece."}
          </p>
          <h5>Final Thoughts</h5>
          <p style={answerStyle}>
          {"It has been really great to see the tournament grow week over week.  I'm working on some site updates that will allow for keeping your deck hidden until after the tournament has been completed.  As part of that effort the User Home section now has a grid of all your decks.  The biggest struggle to date has been gathering everyones ETH Public wallet address for prize distribution, I will be incorporating that into the checkin process as well."}
          </p>
        </div>
          <ArticleComments articleId={"9"} />
      </div>


    );
  }
}

export default Friday3;



// WEBPACK FOOTER //
// ./src/Articles/Friday3.js